import React from "react";
import styled from "styled-components";
import { useParams } from "react-router-dom";
import { usePhotoSeriesGet } from "hooks/citajteo/photo_series/usePhotoSeriesGet";
import PhotoSeriesEditNav from "components/admin/common/photo_series/nav/PhotoSeriesEditNav";
import SeriesPhotoFileEdit from "components/admin/common/photo_series/photo/SeriesPhotoFileEdit";

const PhotoSeriesEditPhoto: React.FC = () => {
  const { itemId = "" } = useParams<{ itemId?: string }>();
  const photoSeries = usePhotoSeriesGet(itemId);

  if (!photoSeries) {
    return <Div>Učitavanje foto serije...</Div>;
  }

  return (
    <Div>
      <PhotoSeriesEditNav photoSer={photoSeries} />
      <SeriesPhotoFileEdit photoSer={photoSeries} />
    </Div>
  );
};

export default PhotoSeriesEditPhoto;

const Div = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;
